import React from "react";

/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { RoundMoneyStats } from "../gameStats";

interface MoneyHistogramProps {
	data: RoundMoneyStats[];
}

const chartStyle = css`
	display: flex;
	align-items: flex-end;
	gap: 0.5rem;
	height: 8rem;
	width: max-content;
	min-width: 100%;
	padding: 0.5rem 0.25rem 0;
	border-bottom: 1px solid currentColor;
`;

const chartViewportStyle = css`
	max-width: 100%;
	overflow-x: auto;
`;

const columnStyle = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	min-width: 2.5rem;
	height: 100%;
`;

const barsStyle = css`
	display: flex;
	align-items: flex-end;
	justify-content: center;
	gap: 0.15rem;
	height: 100%;
`;

const barStyle = css`
	width: 0.7rem;
	min-height: 2px;
	border-radius: 2px 2px 0 0;
`;

export const MoneyHistogram = ({ data }: MoneyHistogramProps) => {
	if (data.length === 0) return null;

	const maxValue = Math.max(1, ...data.flatMap(entry => [entry.spent, entry.gained]));

	return (
		<div>
			<h4>Money by round</h4>
			<div css={chartViewportStyle}>
				<div css={chartStyle}>
					{data.map(entry => (
						<div css={columnStyle} key={entry.round}>
							<div css={barsStyle} title={`Round ${entry.round}: gained ${entry.gained}, spent ${entry.spent}`}>
								<div css={[barStyle, css`height: ${Math.max(0, entry.gained) / maxValue * 100}%; background: #4c9f70;`]} />
								<div css={[barStyle, css`height: ${Math.max(0, entry.spent) / maxValue * 100}%; background: #c95b5b;`]} />
							</div>
							<span>R{entry.round}</span>
						</div>
					))}
				</div>
			</div>
			<div>
				<span style={{ color: "#4c9f70" }}>Gained</span>{" / "}
				<span style={{ color: "#c95b5b" }}>Spent</span>
			</div>
		</div>
	);
};
